import classNames from 'classnames';
import { CSSProperties, MouseEventHandler } from 'react';
import styles from './BaseButton.module.scss';
import CustomIcon, { IconName } from '../CustomIcon';

export type IconPosition = 'before' | 'after';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'success';

type Props = {
  onClick?: MouseEventHandler | undefined;
  className?: string;
  style?: CSSProperties | undefined;
  text: string | undefined;
  icon?: IconName;
  iconPosition?: IconPosition;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  variant?: ButtonVariant;
  isDisabled?: boolean;
};

export const BaseButton = ({
  onClick,
  className,
  style,
  text,
  icon,
  iconPosition,
  type,
  variant = 'primary',
  isDisabled = false,
}: Props): React.ReactElement => {
  return (
    <button
      className={classNames(styles.button, styles[variant], className)}
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      style={style}
    >
      {iconPosition === 'before' && icon && (
        <CustomIcon name={icon} className={classNames(styles.icon)} />
      )}
      <span>{text}</span>
      {iconPosition === 'after' && icon && (
        <CustomIcon name={icon} className={classNames(styles.icon)} />
      )}
    </button>
  );
};
